import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useData } from '@app/core/provider';
import { useSession } from '@app/core/auth';
import { close as closeStream } from '@app/core/stream';
import { toastError } from './feedback';

/** User + tenant menu. Tenant switch clears the WHOLE cache and reconnects the stream (scenario S1.6). */
export function UserMenu() {
  const { data } = useData();
  const { me } = useSession();
  const qc = useQueryClient();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const logout = async () => {
    try { await data.session.logout(); } catch (e) { toastError(e); return; }
    closeStream(); qc.clear(); nav('/login', { replace: true });
  };
  const switchTo = async (id: string) => {
    try { await data.session.switchTenant(id); } catch (e) { toastError(e); return; }
    closeStream(); qc.clear(); location.assign('/today');
  };
  return (
    <div className="app-menu">
      <button type="button" className="app-menu__btn" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((o) => !o)}>
        <span className="stg-avatar" style={{ ['--c' as string]: '#8b7fff', width: 26, height: 26, fontSize: 10 }} aria-hidden>{me.user.first_name[0]}{me.user.last_name[0]}</span>
        <span className="app-menu__name">{me.user.first_name}</span>
      </button>
      {open && (
        <div className="app-menu__pop" role="menu" onMouseLeave={() => setOpen(false)}>
          <div className="app-menu__who"><b>{me.user.first_name} {me.user.last_name}</b><span>{me.user.email}</span><span className="stg-muted">{me.user.role}</span></div>
          {me.tenants.length > 1 && me.tenants.filter((t) => t.id !== me.tenant.id).map((t) => (
            <button key={t.id} type="button" role="menuitem" onClick={() => switchTo(t.id)}>Switch to {t.name}</button>
          ))}
          <button type="button" role="menuitem" onClick={() => { setOpen(false); nav('/settings'); }}>Settings</button>
          {/* Only when the server runs with the second sign-in step switched on: otherwise there is nothing to manage. */}
          {me.mfa && <button type="button" role="menuitem" onClick={() => { setOpen(false); nav('/account/security'); }}>Sign-in security</button>}
          <button type="button" role="menuitem" onClick={logout}>Sign out</button>
        </div>
      )}
    </div>
  );
}
